import { render } from "./BaseSpinner.vue?vue&type=template&id=a2bfa3f4&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=a2bfa3f4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\sensualle\\sensualle - pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2bfa3f4"]])

export default __exports__